module.exports = __webpack_public_path__ + "img/full2-min.dc90f6b8.png";